
// @flow
import React, {memo, useState} from 'react';
import { connect, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import IMAGES from '../../constans/images';
import ROUTERS from '../../constans/router';


type Props = {
    subTitle: any,
    title: any,
    description: any,
    rightArrow: any,
    handleClick: any,
    actionButton: any,
    actionButtonLabel: any,
    actionButtonHandle: any,
    accordion: any,
    accordionContent: any,
    data: any
};

const ListItemComponent = ({
                               subTitle,
                               title,
                               description,
                               rightArrow,
                               handleClick,
                               actionButton,
                               actionButtonLabel,
                               actionButtonHandle,
                               accordion,
                               accordionContent,
                               data,
                               downArrowIcon = ''
                       }: Props) => {

    const [expand, setExpand] = useState(false);

    const _handleClick = (e) => {
        if(accordion){
            setExpand(!expand)
        }
        console.log(e,data, 'eeeeeeee');
        if(typeof handleClick == 'function') handleClick(e, data)
    }

    return (
        <>
            <div className="lists__item" onClick={_handleClick}>
                <div className="lists__item__content">
                    {subTitle && <span>{subTitle}</span>}
                    {title && <h3>{title}</h3>}
                    {description && <p>{description}</p>}
                </div>
                {(!rightArrow && !actionButton) ? "" :
                    <div className="lists__item__action">
                        {actionButton && <button onClick={actionButtonHandle}>{actionButtonLabel}</button>}
                        <img src={(!accordion || !expand) ? (downArrowIcon ? downArrowIcon : "/images/icon_arrow_right_s.svg") : "/images/icon_arrow_up_black.svg"}/>
                    </div>
                }
            </div>
            {!accordion ? "" :
                // <div className="lists__item__pan" style={{display: expand ? "block": "none"}}>
                <div className={expand ? "lists__item__pan open" : "lists__item__pan"}>
                    {accordionContent}
                </div>
            }
        </>
    );
}

ListItemComponent.defaultProps = {
    subTitle: false,
    title: false,
    description: false,
    rightArrow: false,
    handleClick: false,
    actionButton: false,
    actionButtonLabel: false,
    actionButtonHandle: false,
    accordion: false,
    accordionContent: false,
    data: {}
};


export default memo(ListItemComponent);
